import "../styles/App.css";
import rightCaret from "../icons/right-caret.svg";

function BasicInfo() {
    return (
        <div className="paragraph">
            <text>
                Amy Y.Q. Lin
                <br />
                B. 1996, Washington D.C. Based in Seattle.
            </text>
            <div className="row">
                <img src={rightCaret} className="caret" alt="caret" />
                <text>Last updated August 28 2026</text>
            </div>
        </div>
    );
}

export default BasicInfo;
